import Decimal from 'decimal.js';
import { normalizeHeader, parseCsv } from './parseCsv';

export function parseDecimalCell(raw: string): Decimal | null {
  const t = String(raw ?? '')
    .trim()
    .replace(/\s/g, '');
  if (!t) return null;
  let x = t;
  if (x.includes(',') && x.includes('.')) {
    x = x.replace(/,/g, '');
  } else if (x.includes(',') && !x.includes('.')) {
    x = x.replace(',', '.');
  }
  try {
    const n = new Decimal(x);
    return n.isFinite() ? n : null;
  } catch {
    return null;
  }
}

export function parseExchangeTs(raw: string): number | null {
  const t = String(raw ?? '').trim();
  if (!t) return null;
  const ms = Date.parse(t.replace(' ', 'T'));
  if (!Number.isNaN(ms)) return ms;
  const m = t.match(/^(\d{1,2})[./-](\d{1,2})[./-](\d{4})/);
  if (m) {
    const d = new Date(Date.UTC(Number(m[3]), Number(m[2]) - 1, Number(m[1])));
    return d.getTime();
  }
  return null;
}

export function findColIdx(headers: string[], patterns: RegExp[]): number | undefined {
  for (let i = 0; i < headers.length; i++) {
    const h = headers[i];
    if (patterns.some((p) => p.test(h))) return i;
  }
  return undefined;
}

export function cell(row: string[], ix: number | undefined): string {
  if (ix === undefined) return '';
  const v = row[ix];
  return v == null ? '' : String(v).trim();
}

export function gridFromCsvText(text: string): string[][] {
  return parseCsv(text.trim());
}

export function headersNormalizedRow0(grid: string[][]): string[] {
  if (grid.length === 0) return [];
  return grid[0].map((c) => normalizeHeader(c));
}
